import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GoogleSheetsBaseService {
  protected http = inject(HttpClient);
  protected googleSheetId = environment.fieldValuesGoogleSheetId;
  protected bdaSheetsApiKey = 'AIzaSyC-5gvjrj0vx82W30NwzAwXe6xLD2eOdVc';

  protected httpOptions = {
    params: {
      'key': this.bdaSheetsApiKey,
      'majorDimension': 'COLUMNS'
    },
    headers: {
      'Content-Type': 'application/json'
    }
  };

  /**
   * Fetches data from a specific range in a Google Sheet.
   * @param tabName The name of the sheet tab.
   * @param startCell The starting cell for the range (e.g., 'A1').
   * @param endCell The ending cell for the range (e.g., 'C10').
   * @returns An Observable of the API response.
   */
  protected getSheetData(tabName: string, startCell: string, endCell: string): Observable<any> {
    const url = `https://sheets.googleapis.com/v4/spreadsheets/${this.googleSheetId}/values/${tabName}!${startCell}:${endCell}`;
    return this.http.get(url, this.httpOptions).pipe(
      map((response: any) => response.values),
      catchError(error => {
        console.error(`Error fetching data from sheet tab: ${tabName}`, error);
        // Return an empty array (not null) so consumers that index the result
        // (e.g. `response[0]`) don't throw and crash the host component. A failed
        // sheet read should degrade to empty dropdowns, never a hard error.
        return of([]);
      })
    );
  }


  /**
   * Fetches data from a specific column in a Google Sheet
   * and maps it to a single array.
   * @param tabName The name of the sheet tab.
   * @param startCell The starting cell for the range (e.g., 'A2').
   * @param endCell The ending cell for the range (e.g., 'A100').
   * @returns An Observable of a clean string array.
   */
  protected getSheetColumnData(tabName: string, startCell: string, endCell: string): Observable<string[]> {
    // This calls the parent class's method to get the raw values.
    return this.getSheetData(tabName, startCell, endCell).pipe(
      map(rawValues => {
        // The parent returns `response.values`. We access the first column
        // and return a clean string array, or an empty array if not found.
        return rawValues?.[0] || [];
      })
    );
  }




}